// Synonym map for JVVNL search. When a user query matches a key (or appears
// inside a key), the listed alternatives are also matched against item text.
// Lowercase everything; matching is substring-based.

export const SEARCH_SYNONYMS: Record<string, string[]> = {
  load: ["demand", "consumption", "usage"],
  demand: ["load", "consumption", "usage"],
  generation: ["gen", "produced", "output", "supply"],
  gen: ["generation", "output"],
  forecast: ["predicted", "projection", "estimate", "prediction"],
  feeder: ["line", "circuit", "distribution"],
  plant: ["generator", "source", "station", "generation"],
  peak: ["maximum", "highest", "max"],
  net: ["total", "overall", "aggregate"],
  temperature: ["temp", "heat", "thermal"],
  humidity: ["moisture", "damp"],
  rain: ["precipitation"],
  wind: ["breeze", "air"],
  substation: ["transco", "gss", "sub"],
  map: ["geography", "location", "geo"],
  metric: ["measurement", "indicator", "stat", "kpi"],
  energy: ["mwh", "consumption", "units", "kwh"],
  weather: ["temperature", "humidity", "rain", "wind", "climate"],
  quality: ["availability", "nulls", "zeros", "completeness", "missing"],
  ranking: ["top", "bottom", "highest", "lowest", "contribution", "rank"],
  bucket: ["morning", "solar", "evening", "window", "period", "slot"],
};

/**
 * Expand a normalized query into the set of terms to match against item text.
 * Always includes the original query. Pulls synonyms when the query equals a
 * key or is contained within one (so "temp" still reaches "temperature").
 */
export function expandQuery(normalizedQuery: string): string[] {
  const terms = new Set<string>([normalizedQuery]);
  // Skip synonym expansion for very short queries — substring key-matching on
  // 1-2 chars over-expands and adds noise. The literal term still matches.
  if (normalizedQuery.length < 3) return Array.from(terms);
  for (const [key, alts] of Object.entries(SEARCH_SYNONYMS)) {
    if (key === normalizedQuery || key.includes(normalizedQuery)) {
      alts.forEach((a) => terms.add(a));
    }
  }
  return Array.from(terms);
}
